export { default } from './SocialMediaLink';
